const mapUrls = {
  traviss: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3522.939670881977!2d-81.8924064!3d27.995742099999994!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88dd3e4154e61563%3A0x269b5245a3853191!2sTraviss%20Technical%20College!5e0!3m2!1sen!2sus!4v1790291162518!5m2!1sen!2sus',
  lively: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3430.347291815124!2d-84.3214561!3d30.4512342!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88ecf5123456789a%3A0x123456789abcdef0!2sLively%20Technical%20College!5e0!3m2!1sen!2sus!4v1790291162518!5m2!1sen!2sus',
  palmBeach: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3567.89123456789!2d-80.1512341!3d26.6123452!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88d928123456789a%3A0x123456789abcdef0!2sPalm%20Beach%20State%20College!5e0!3m2!1sen!2sus!4v1790291162518!5m2!1sen!2sus',
  indianRiver: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3512.34567890123!2d-80.3512341!3d27.4212342!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88de5123456789ab%3A0x123456789abcdef0!2sIndian%20River%20State%20College!5e0!3m2!1sen!2sus!4v1790291162518!5m2!1sen!2sus',
  seminole: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3501.23456789012!2d-81.3123451!3d28.7123452!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88e7123456789abc%3A0x123456789abcdef0!2sSeminole%20State%20College%20of%20Florida!5e0!3m2!1sen!2sus!4v1790291162518!5m2!1sen!2sus',
  daytona: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3498.12345678901!2d-81.0212341!3d29.2123452!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88e68123456789ab%3A0x123456789abcdef0!2sDaytona%20State%20College!5e0!3m2!1sen!2sus!4v1790291162518!5m2!1sen!2sus',
  tallahassee: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3431.23456789012!2d-84.3512341!3d30.4312342!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88ecf123456789ab%3A0x123456789abcdef0!2sTallahassee%20Community%20College!5e0!3m2!1sen!2sus!4v1790291162518!5m2!1sen!2sus',
  pensacola: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3421.23456789012!2d-87.2123451!3d30.4312342!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8890bc123456789a%3A0x123456789abcdef0!2sPensacola%20State%20College!5e0!3m2!1sen!2sus!4v1790291162518!5m2!1sen!2sus',
  fscj: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3445.12345678901!2d-81.6512341!3d30.3312342!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88e4b123456789ab%3A0x123456789abcdef0!2sFlorida%20State%20College%20at%20Jacksonville!5e0!3m2!1sen!2sus!4v1790291162518!5m2!1sen!2sus',
  southFloridaState: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3545.12345678901!2d-81.5123451!3d27.4812342!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88dda123456789ab%3A0x123456789abcdef0!2sSouth%20Florida%20State%20College!5e0!3m2!1sen!2sus!4v1790291162518!5m2!1sen!2sus',
  atlantic: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3581.23456789012!2d-80.1812341!3d26.2512342!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88d90123456789ab%3A0x123456789abcdef0!2sAtlantic%20Technical%20College!5e0!3m2!1sen!2sus!4v1790291162518!5m2!1sen!2sus',
  eastern: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3509.12345678901!2d-80.7312341!3d28.3812342!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88de0123456789ab%3A0x123456789abcdef0!2sEastern%20Florida%20State%20College!5e0!3m2!1sen!2sus!4v1790291162518!5m2!1sen!2sus',
  cbt: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3598.12345678901!2d-80.3212341!3d25.7612342!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88d9b123456789ab%3A0x123456789abcdef0!2sCollege%20of%20Business%20and%20Technology!5e0!3m2!1sen!2sus!4v1790291162518!5m2!1sen!2sus',
  erwin: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3523.12345678901!2d-82.4512341!3d27.9712342!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88c2c123456789ab%3A0x123456789abcdef0!2sD.G.%20Erwin%20Technical%20Center!5e0!3m2!1sen!2sus!4v1790291162518!5m2!1sen!2sus',
  firstCoast: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3458.12345678901!2d-81.3123451!3d29.9012342!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88e4123456789ab%3A0x123456789abcdef0!2sFirst%20Coast%20Technical%20College!5e0!3m2!1sen!2sus!4v1790291162518!5m2!1sen!2sus',
  fortis: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3422.12345678901!2d-87.2123451!3d30.4512342!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8890b123456789ab%3A0x123456789abcdef0!2sFortis%20Institute!5e0!3m2!1sen!2sus!4v1790291162518!5m2!1sen!2sus',
  southeastern: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3568.12345678901!2d-80.1212341!3d26.1812342!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88d90123456789ab%3A0x123456789abcdef0!2sSoutheastern%20College!5e0!3m2!1sen!2sus!4v1790291162518!5m2!1sen!2sus',
  southern: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3502.12345678901!2d-81.3712341!3d28.5312342!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88e77123456789ab%3A0x123456789abcdef0!2sSouthern%20Technical%20College!5e0!3m2!1sen!2sus!4v1790291162518!5m2!1sen!2sus',
  aviation: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3501.12345678901!2d-81.3312341!3d28.6512342!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88e70123456789ab%3A0x123456789abcdef0!2sAviation%20Institute%20of%20Maintenance!5e0!3m2!1sen!2sus!4v1790291162518!5m2!1sen!2sus',
  dmac: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3581.12345678901!2d-80.1512341!3d25.9512342!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88d9123456789ab%3A0x123456789abcdef0!2sDMAC%20Tech!5e0!3m2!1sen!2sus!4v1790291162518!5m2!1sen!2sus',
  southFloridaAcademy: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3582.12345678901!2d-80.2123451!3d26.1212342!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88d90123456789ab%3A0x123456789abcdef0!2sSouth%20Florida%20Academy%20of%20AC!5e0!3m2!1sen!2sus!4v1790291162518!5m2!1sen!2sus',
  hvacAcademy: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3591.12345678901!2d-80.2512341!3d25.8112342!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88d9b123456789ab%3A0x123456789abcdef0!2sHVAC%20Technical%20Academy!5e0!3m2!1sen!2sus!4v1790291162518!5m2!1sen!2sus',
  emerald: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3412.12345678901!2d-86.2912341!3d30.7212342!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x889123456789ab%3A0x123456789abcdef0!2sEmerald%20Coast%20Technical%20College!5e0!3m2!1sen!2sus!4v1790291162518!5m2!1sen!2sus',
  northFlorida: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3451.12345678901!2d-83.3712341!3d30.4712342!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88eaf123456789ab%3A0x123456789abcdef0!2sNorth%20Florida%20College!5e0!3m2!1sen!2sus!4v1790291162518!5m2!1sen!2sus',
  florida: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3468.12345678901!2d-82.3412341!3d29.6412342!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88e62123456789ab%3A0x123456789abcdef0!2sUniversity%20of%20Florida!5e0!3m2!1sen!2sus!4v1790291162518!5m2!1sen!2sus',
  georgeStone: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3425.12345678901!2d-87.3112341!3d30.4812342!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8890c123456789ab%3A0x123456789abcdef0!2sGeorge%20Stone%20Technical%20College!5e0!3m2!1sen!2sus!4v1790291162518!5m2!1sen!2sus'
};

const createProgram = (program) => ({
  ...program,
  badge: program.badge || 'Florida HVAC training',
  specs: [
    ['Program type', program.type],
    ['Cost', program.cost],
    ['Length', program.length],
    ['Credential', program.credential]
  ],
  paragraphs: [program.description],
  highlights: program.highlights || [
    'Hands-on technical instruction',
    'Electrical and refrigeration fundamentals',
    'Preparation for HVAC career pathways'
  ]
});

const programData = [
  {
    name: 'Traviss Technical College',
    type: 'Air Conditioning, Refrigeration, and Heating Technology',
    cost: 'Approximately $2,950 plus fees and books',
    length: '750 clock hours',
    credential: 'Career Certificate',
    address: 'Lakeland, Florida',
    mapEmbedUrl: mapUrls.traviss,
    description: 'Traviss Technical College offers a comprehensive, hands-on program covering electrical theory, component repair, and system installation. The intensive schedule is designed to align with state certification requirements and prepare students for entry-level technician roles with central Florida contractors.'
  },
  {
    name: 'Lively Technical College',
    type: 'HVAC/R training',
    cost: 'Approximately $2,900 plus material fees',
    length: '750 clock hours',
    credential: 'Career Certificate',
    address: 'Tallahassee, Florida',
    mapEmbedUrl: mapUrls.lively,
    description: 'Lively Technical College provides practical HVAC/R training in electrical wiring, piping, climate-control diagnostics, system maintenance, and residential and commercial applications for students entering the Florida panhandle workforce.'
  },
  {
    name: 'Palm Beach State College',
    type: 'Online HVAC/R Technician training',
    cost: 'Approximately $2,495 with material vouchers',
    length: 'Self-paced online pathway',
    credential: 'HVAC/R technician training certificate',
    address: 'Lake Worth, Florida',
    mapEmbedUrl: mapUrls.palmBeach,
    description: 'Palm Beach State College offers a flexible online and career-focused pathway through Ed2Go/Career Step. The curriculum covers thermodynamics, automatic controls, service fundamentals, EPA Section 608 preparation, and NATE certification preparation.'
  },
  {
    name: 'Indian River State College',
    type: 'Air Conditioning, Refrigeration, and Heating',
    cost: 'Approximately $85 per credit hour for Florida residents',
    length: 'Certificate and degree pathway',
    credential: 'Stackable technical certificates and A.S. options',
    address: 'Fort Pierce, Florida',
    mapEmbedUrl: mapUrls.indianRiver,
    description: 'Indian River State College combines affordable public-college tuition with hands-on laboratory instruction in installation, preventive maintenance, and diagnostic repair for modern environmental systems across Florida’s Treasure Coast.'
  },
  {
    name: 'Seminole State College of Florida',
    type: 'Online and hybrid HVACR Technician training',
    cost: 'Approximately $2,495',
    length: 'Approximately 330 hours',
    credential: 'HVACR technician training certificate',
    address: 'Sanford, Florida',
    mapEmbedUrl: mapUrls.seminole,
    description: 'Seminole State College offers self-paced online and hybrid training for adult career transitioners. The program covers electrical systems, refrigeration loops, commercial diagnostics, EPA Universal Section 608 preparation, a starter tool kit, and exam vouchers.'
  },
  {
    name: 'Daytona State College',
    type: 'HVAC Technology',
    cost: 'Approximately $108 per credit hour for Florida residents',
    length: 'Technical certificate and A.S. pathways',
    credential: 'Technical certificate or Associate of Science',
    address: 'Daytona Beach, Florida',
    mapEmbedUrl: mapUrls.daytona,
    description: 'Daytona State College provides accessible hands-on HVAC training through its public community college system. Students practice shop work, electrical troubleshooting, and service procedures for residential and commercial equipment.'
  },
  {
    name: 'Tallahassee Community College',
    type: 'Heating, ventilation, and air conditioning',
    cost: 'Approximately $101 per credit hour',
    length: 'Career and technical pathway',
    credential: 'Technical certificate',
    address: 'Tallahassee, Florida',
    mapEmbedUrl: mapUrls.tallahassee,
    description: 'Tallahassee Community College combines classroom theory with practical laboratory experience covering heating, ventilation, and air conditioning systems. Its technical pathways support rapid entry into the regional mechanical workforce.'
  },
  {
    name: 'Pensacola State College',
    type: 'Air Conditioning, Refrigeration, and Heating Technology',
    cost: 'Approximately $105 per credit hour',
    length: '750 clock hours',
    credential: 'HVAC-VC vocational certificate',
    address: 'Pensacola, Florida',
    mapEmbedUrl: mapUrls.pensacola,
    description: 'Pensacola State College offers a vocational certificate with hands-on training in electrical schematics, brazing, system diagnostics, and refrigerant-related service procedures in campus laboratories.'
  },
  {
    name: 'Florida State College at Jacksonville',
    type: 'Air Conditioning, Refrigeration, and Heating Technology, Program 6014',
    cost: 'Approximately $114 per credit hour',
    length: 'Technical certificate pathway',
    credential: 'Technical certificate',
    address: 'Jacksonville, Florida',
    mapEmbedUrl: mapUrls.fscj,
    description: 'Florida State College at Jacksonville provides a technical certificate covering installation, maintenance, and repair principles for residential and light commercial equipment. Students can access financial aid and regional employer networks.'
  },
  {
    name: 'South Florida State College',
    type: 'Air Conditioning, Refrigeration, and Heating Technology',
    cost: 'Standard public college tuition rates',
    length: 'Structured clock-hour sequence',
    credential: 'Technical certificate',
    address: 'Avon Park, Florida',
    mapEmbedUrl: mapUrls.southFloridaState,
    description: 'South Florida State College delivers classroom and shop instruction in servicing, troubleshooting, and installing climate-control systems. The program prepares students for certification eligibility and local contractor employment.'
  },
  {
    name: 'Atlantic Technical College',
    type: 'HVACR technology',
    cost: 'Approximately $2,950 plus fees',
    length: '750 clock hours',
    credential: 'Career and trade certificate',
    address: 'Fort Lauderdale, Florida',
    mapEmbedUrl: mapUrls.atlantic,
    description: 'Atlantic Technical College trains students on residential and commercial equipment through dedicated workshops covering electrical theory, duct design, mechanical troubleshooting, and practical system service.'
  },
  {
    name: 'Eastern Florida State College',
    type: 'Applied Technology Diploma in HVAC',
    cost: 'Approximately $103 per credit hour',
    length: 'Applied Technology Diploma pathway',
    credential: 'Applied Technology Diploma',
    address: 'Cocoa, Florida',
    mapEmbedUrl: mapUrls.eastern,
    description: 'Eastern Florida State College offers an Applied Technology Diploma blending affordable public tuition with practical lab training in heating systems, air distribution, and electrical troubleshooting. The pathway supports state licensing education requirements.'
  },
  {
    name: 'College of Business and Technology',
    type: 'HVAC technician training',
    cost: 'Varies by aid eligibility and financing',
    length: 'Several months',
    credential: 'HVAC technician training certificate',
    address: 'Miami, Florida',
    mapEmbedUrl: mapUrls.cbt,
    description: 'College of Business and Technology combines classroom lectures with interactive labs focused on electrical circuits, refrigeration cycles, diagnostic procedures, EPA Section 608 preparation, and career placement assistance.'
  },
  {
    name: 'D.G. Erwin Technical Center',
    type: 'HVAC/R systems',
    cost: 'Approximately $2,950',
    length: '750 clock hours',
    credential: 'Vocational certificate',
    address: 'Tampa, Florida',
    mapEmbedUrl: mapUrls.erwin,
    description: 'D.G. Erwin Technical Center provides intensive workshop training in residential and commercial installation, electrical controls, preventive maintenance, and practical HVAC/R service skills.'
  },
  {
    name: 'First Coast Technical College',
    type: 'HVAC training',
    cost: 'Standard district postsecondary tuition rates',
    length: '750 clock hours',
    credential: 'Vocational certificate',
    address: 'St. Augustine, Florida',
    mapEmbedUrl: mapUrls.firstCoast,
    description: 'First Coast Technical College emphasizes direct practical skill acquisition for service calls across northeast Florida. Students study electrical diagnostics, refrigerant handling, and system troubleshooting.'
  },
  {
    name: 'Fortis Institute',
    type: 'HVAC training diploma',
    cost: 'Varies by campus and financial aid plan',
    length: 'Structured diploma program',
    credential: 'HVAC training diploma',
    address: 'Pensacola, Port St. Lucie, and Orange Park, Florida',
    mapEmbedUrl: mapUrls.fortis,
    description: 'Fortis Institute offers HVAC diploma training at multiple Florida campuses. Classroom instruction and hands-on shop work cover electrical controls, heating systems, air conditioning repair, and industry certification preparation.'
  },
  {
    name: 'Southeastern College',
    type: 'HVAC training',
    cost: 'Institutional tuition rates with aid available',
    length: 'Focused vocational program',
    credential: 'Vocational HVAC credential',
    address: 'South Florida',
    mapEmbedUrl: mapUrls.southeastern,
    description: 'Southeastern College focuses on diagnostic practice, electrical wiring fundamentals, safe refrigerant handling, and the practical technical skills needed by modern mechanical contractors.'
  },
  {
    name: 'Southern Technical College',
    type: 'HVAC diploma program',
    cost: 'Institutional credit or clock-hour pricing',
    length: 'Flexible scheduling',
    credential: 'HVAC diploma',
    address: 'Auburndale, Brandon, Orlando, Sanford, and Port Charlotte, Florida',
    mapEmbedUrl: mapUrls.southern,
    description: 'Southern Technical College provides career-oriented HVAC diploma programs for adult learners. Students balance technical theory with hands-on lab work in electrical troubleshooting, maintenance, and component repair.'
  },
  {
    name: 'Aviation Institute of Maintenance',
    type: 'Heating, Ventilation, and Air Conditioning',
    cost: 'Specialized trade school financial package',
    length: 'Career training program',
    credential: 'HVAC training credential',
    address: 'Casselberry, Florida',
    mapEmbedUrl: mapUrls.aviation,
    description: 'Aviation Institute of Maintenance offers practical HVAC training in electrical theory, refrigeration loops, heat pumps, brazing, and tool mastery. Graduates can prepare for credentials such as EPA Universal and OSHA safety certifications.'
  },
  {
    name: 'DMAC HVAC School Training',
    type: 'Residential and commercial HVAC training',
    cost: 'Flat certificate package fee',
    length: 'Fast-paced certificate program',
    credential: 'Targeted training certificate',
    address: 'South Florida',
    mapEmbedUrl: mapUrls.dmac,
    description: 'DMAC HVAC School Training delivers focused instruction in equipment diagnostics, electrical troubleshooting, and component repair for aspiring technicians seeking practical readiness for local service contractors.'
  },
  {
    name: 'South Florida Academy of AC',
    type: 'Air conditioning service training',
    cost: 'Direct vocational enrollment fees',
    length: 'Concentrated trade instruction',
    credential: 'Specialized HVAC certificate',
    address: 'South Florida',
    mapEmbedUrl: mapUrls.southFloridaAcademy,
    description: 'South Florida Academy of AC provides concentrated hands-on instruction in diagnostics, electrical troubleshooting, and practical repair techniques for students entering the regional air conditioning service sector.'
  },
  {
    name: 'HVAC Technical Academy',
    type: 'HVAC installation and repair',
    cost: 'Flat-rate program fee including materials',
    length: 'Focused vocational program',
    credential: 'Vocational certificate',
    address: 'South Florida',
    mapEmbedUrl: mapUrls.hvacAcademy,
    description: 'HVAC Technical Academy teaches core heating, ventilation, and air conditioning fundamentals through practical shop work, materials-based training, and preparation for critical licensing exams.'
  },
  {
    name: 'Emerald Coast Technical College',
    type: 'Air Conditioning, Refrigeration, and Heating Technology',
    cost: 'Approximately $2,950',
    length: '750 clock hours',
    credential: 'Career certificate',
    address: 'DeFuniak Springs, Florida',
    mapEmbedUrl: mapUrls.emerald,
    description: 'Emerald Coast Technical College serves the Florida panhandle with hands-on training in electrical wiring, duct fabrication, and diagnostic servicing of modern climate-control equipment.'
  },
  {
    name: 'North Florida College',
    type: 'Career and technical education',
    cost: 'Approximately $103 per credit hour',
    length: 'Career and technical pathway',
    credential: 'Technical training credential',
    address: 'Madison, Florida',
    mapEmbedUrl: mapUrls.northFlorida,
    description: 'North Florida College supports rural and regional workforce needs with budget-friendly public tuition, foundational technical instruction, financial aid, and advising for students entering trade and industrial careers.'
  },
  {
    name: 'University of Florida',
    type: 'Mechanical engineering and building sciences',
    cost: 'Approximately $6,380 per year for Florida residents',
    length: 'Undergraduate degree pathway',
    credential: 'Advanced academic degree',
    address: 'Gainesville, Florida',
    mapEmbedUrl: mapUrls.florida,
    description: 'The University of Florida provides advanced academic pathways in engineering and related technical fields. It is suited to students pursuing high-level technical leadership, mechanical engineering, building sciences, and research rather than a vocational HVAC certificate.'
  },
  {
    name: 'George Stone Technical College',
    type: 'Air Conditioning, Refrigeration, and Heating Technology',
    cost: 'Approximately $2,950',
    length: '750 clock hours',
    credential: 'Vocational certificate',
    address: 'Pensacola, Florida',
    mapEmbedUrl: mapUrls.georgeStone,
    description: 'George Stone Technical College offers rigorous workshop training in electrical troubleshooting, system installation, refrigerant recovery standards, and practical HVAC service for students preparing for immediate employment and state licensing.'
  }
];

export const programs = programData.map(createProgram);

export const resources = [
  {
    title: 'U.S. Environmental Protection Agency',
    description: 'EPA refrigerant handling and Section 608 certification information.',
    url: 'https://www.epa.gov/section608'
  },
  {
    title: 'Florida Department of Education',
    description: 'Career and technical education resources for Florida students.',
    url: 'https://www.fldoe.org/academics/career-adult-edu/'
  },
  {
    title: 'U.S. Bureau of Labor Statistics',
    description: 'Employment outlook and occupational information for HVAC technicians.',
    url: 'https://www.bls.gov/ooh/installation-maintenance-and-repair/heating-air-conditioning-and-refrigeration-mechanics-and-installers.htm'
  }
];